import React, { useState } from "react";
import { AiOutlinePlus, AiOutlineClose } from "react-icons/ai";

interface Props {
  name: string;
  value: string[]; // now supports multiple
  onChange: (event: { target: { name: string; value: string[] } }) => void;
  type?: "email" | "text" | "password" | "number" | "date" | "tel" | "search";
  placeholder?: string;
  required?: boolean;
  label?: string;
  id?: string;
  className?: string;
  inputClassName?: string;
  readOnly?: boolean;
  disabled?: boolean;
  min?: string;
  max?: string;
}

export default function CustomListInput({
  name,
  value,
  onChange,
  type = "text",
  placeholder,
  required = false,
  label,
  id,
  inputClassName,
  className,
  readOnly,
  disabled,
  min,
  max,
}: Props) {
  const [inputValue, setInputValue] = useState("");

  const handleAdd = () => {
    const trimmed = inputValue.trim();
    if (trimmed && !value.includes(trimmed)) {
      onChange({ target: { name, value: [...value, trimmed.toUpperCase()] } });
      setInputValue("");
    }
  };

  const handleRemove = (item: string) => {
    onChange({
      target: { name, value: value.filter((v) => v !== item) },
    });
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAdd();
    }
  };

  return (
    <div
      className={`flex flex-col gap-2 w-full relative ${className ?? ""} ${
        disabled ? "opacity-50" : ""
      }`}>
      {label && (
        <label
          htmlFor={id || name}
          className="text-sm font-medium text-text-main">
          {label}
        </label>
      )}

      {/* Input Field */}
      <div className="flex items-center gap-2 relative">
        <input
          id={id || name}
          name={name}
          type={type}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          onBlur={handleAdd}
          placeholder={placeholder}
          required={required}
          readOnly={readOnly}
          disabled={disabled}
          min={min}
          max={max}
          className={`px-4 py-2 border border-brand-secondary rounded-10 outline-none focus:ring-2 focus:ring-brand-main focus:border-brand-main bg-white text-sm text-gray-800 placeholder-gray-400 transition flex-1 ${
            inputClassName ?? ""
          }`}
        />

        {/* Add Button */}
        <button
          type="button"
          // onClick={handleAdd}
          disabled={disabled || readOnly}
          className="p-2 rounded-full bg-brand-main text-white hover:opacity-90 transition disabled:opacity-50">
          <AiOutlinePlus size={18} />
        </button>
      </div>

      {/* Added Items */}
      <div className="flex flex-wrap gap-2 mt-1">
        {value.map((item, index) => (
          <div
            key={index}
            className="flex items-center bg-brand-secondary text-white px-3 py-1 rounded-full text-sm">
            <span>{item}</span>
            <button
              type="button"
              onClick={() => handleRemove(item)}
              className="ml-2 hover:text-red-400">
              <AiOutlineClose size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
